import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule} from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Router } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { TawkMessengerAngularModule } from '@tawk.to/tawk-messenger-angular';
// import { TawkComponent } from './_components/tawk/tawk.component';

// import { WindowRef } from './_services/windowref.service';
import { WINDOW, WINDOW_PROVIDERS } from './_providers/window.provider';
// import { WindowRefService } from './_providers/window-ref.provider';

import { environment } from '../environments/environment';
import { provideAnalytics,getAnalytics,ScreenTrackingService,UserTrackingService } from '@angular/fire/analytics';
import { provideAuth,getAuth } from '@angular/fire/auth';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { provideDatabase,getDatabase } from '@angular/fire/database';
import { provideFirestore,getFirestore } from '@angular/fire/firestore';
import { provideFunctions,getFunctions } from '@angular/fire/functions';
import { provideMessaging,getMessaging } from '@angular/fire/messaging';
import { providePerformance,getPerformance } from '@angular/fire/performance';
import { provideRemoteConfig,getRemoteConfig } from '@angular/fire/remote-config';
import { provideStorage,getStorage } from '@angular/fire/storage';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
// import { CodeEditorModule } from '@ngstack/code-editor';
// import { MainComponent } from './main/main.component';
import { LoaderModule } from './_services/loader/loader.module';
import { LoaderService } from './_services/loader/loader.service';
import { TWADialogsService } from './_services/twa-dialogs.service';
import { ServerConn, serverConnCreator } from './_services/serverConn.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { SidenavComponent } from './_components/sidenav.component';
import { ClientHeaderModule } from './_components/client-header/client-header.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AnalyticsClickDirectiveModule } from './_directives/analytics-click-directive.directive';
registerLocaleData(localeEs);

@NgModule({
  declarations: [
      AppComponent,
      // MainComponent
      // TawkComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatMenuModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatDialogModule,
    MatDatepickerModule,
    MatIconModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatButtonModule,
    MatListModule,
    MatTooltipModule,
    ClientHeaderModule,
    NgxSpinnerModule,
    TourMatMenuModule,
    SidenavComponent,
    AnalyticsClickDirectiveModule,
    // TawkMessengerAngularModule,
    // CodeEditorModule.forRoot(),
    LoaderModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
    })],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    providePerformance(() => getPerformance()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideStorage(() => getStorage()),
    WINDOW_PROVIDERS,
    // WindowRefService,
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    {
        provide: ServerConn,
        useFactory: serverConnCreator,
        deps: [
            HttpClient,
            Router,
            LoaderService,
            WINDOW,
            TWADialogsService,
            AngularFireAuth,
            MatSnackBar,
        ]
    },
    {
        provide: MAT_DATE_LOCALE, useValue: 'es-ES'
    },
    ScreenTrackingService, UserTrackingService,
    provideHttpClient(withInterceptorsFromDi()),
] })
export class AppModule { }
